module.exports = __webpack_public_path__ + "img/part4-uIcon23.00f7ca92.png";